import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import HostAwareRoot from "./pages/HostAwareRoot";
import LaunchDay from "./pages/LaunchDay";
import MogulMarketplace from "./pages/MogulMarketplace";
import Limits from "./pages/Limits";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Brands from "./pages/Brands";
import BrandDetail from "./pages/BrandDetail";
import KnowledgeFlags from "./pages/KnowledgeFlags";
import CalendarPage from "./pages/CalendarPage";
import Approvals from "./pages/Approvals";
import Onboarding from "./pages/Onboarding";
import Workspaces from "./pages/Workspaces";
import AcceptInvite from "./pages/AcceptInvite";
import Pricing from "./pages/Pricing";
import Billing from "./pages/Billing";
import Affiliate from "./pages/Affiliate";
import MogulMode from "./pages/MogulMode";
import PublicMogul from "./pages/PublicMogul";
import Sponsorships from "./pages/Sponsorships";
import Strategy from "./pages/Strategy";
import Layout from "./components/Layout";

function CaptureRef() {
  // Persist ?ref= to localStorage on any page load
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem("vit_ref", ref);
      // fire-and-forget click tracking
      try {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/affiliate/track-click`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code: ref }),
        });
      } catch (_) {}
    }
  }, []);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id in URL fragment synchronously BEFORE other routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HostAwareRoot />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/operators" element={<MogulMarketplace />} />
      <Route path="/accept-invite/:token" element={<AcceptInvite />} />
      <Route path="/m/:slug" element={<PublicMogul />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/launch-day" element={<LaunchDay />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/brands/:brandId" element={<BrandDetail />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/flags" element={<KnowledgeFlags />} />
        <Route path="/strategy" element={<Strategy />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/workspaces" element={<Workspaces />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/affiliate" element={<Affiliate />} />
        <Route path="/mogul-mode" element={<MogulMode />} />
        <Route path="/sponsorships" element={<Sponsorships />} />
        <Route path="/limits" element={<Limits />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <CaptureRef />
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
